import { defineStore, acceptHMRUpdate } from 'pinia';
import utilitiesData from '../../utilities/common/data';
import eventRepository from '../../repositories/event/eventRepository';
import mediaRepository from '../../repositories/general/mediaRepository';

const dataEvent = {
  name: null,
  location: null,
  image: null,
  date: null,
  image_collect: [],
  content: null,
};

export const useEventStore = defineStore('eventStore', {
  state: () => ({
    componentKey: 0,
    isSuccess: false,
    hasErrorSingle: null,
    // list page
    perpage: 20,
    search: null,
    page: 1,
    listData: [],
    pagination: {},
    isLoadingTable: false,
    // form page
    formData: structuredClone(dataEvent),
    hasFormError: structuredClone(dataEvent),
    isLoadingForm: false,
  }),
  actions: {
    async getData() {
      try {
        this.isLoadingTable = true;
        this.hasErrorSingle = null;
        this.isSuccess = false;

        const params = {
          search: this.search,
          page: this.page,
          perpage: this.perpage,
        };
        const dataEvent = await eventRepository.getData(params);
        if (dataEvent.data.status === 200) {
          this.listData = dataEvent.data.data.event.list;
          this.pagination = dataEvent.data.data.event.pagination;
          this.isLoadingTable = false;
          this.componentKey++;
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isLoadingTable = false;
        this.isSuccess = false;
      }
    },
    async searchData() {
      this.page = 1;
      await this.getData();
    },
    async getDataByPaging() {
      await this.getData();
    },
    async saveData() {
      try {
        this.isLoadingForm = true;
        this.isSuccess = false;
        this.resetForm(false, false);

        const params = this.formData;
        const saveEvent = await eventRepository.saveData(params);
        if (saveEvent.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async getDataDetail(id) {
      this.isSuccess = false;

      const params = {
        event_id: id,
      };
      const dataDetailEvent = await eventRepository.getDataDetail(params);

      if (dataDetailEvent.data.status === 200) {
        this.isSuccess = true;
        const data = dataDetailEvent.data.data;

        this.formData.name = data.name;
        this.formData.location = data.location;
        this.formData.date = data.date;
        this.formData.content = data.desc;
        this.formData.image = data.image.file_id;
        this.formData.image_collect = data.image;
      }
    },
    async updateData(id) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const params = {
          event_id: id,
          ...this.formData,
        };
        const updateEvent = await eventRepository.updateData(params);
        if (updateEvent.data.status === 200) {
          this.isSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.log(error);
        this.setFormError(error.response.data.error);
        this.isSuccess = false;
        this.isLoadingForm = false;
      }
    },
    async deleteData(id) {
      try {
        this.isSuccess = false;

        const params = {
          event_id: id,
        };
        const deleteEvent = await eventRepository.deleteData(params);
        if (deleteEvent.data.status === 200) {
          this.isSuccess = true;
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
      }
    },
    async uploadFile(file, type) {
      try {
        this.isSuccess = false;
        this.isLoadingForm = true;
        this.resetForm(false, false);

        const uploadFile = await mediaRepository.uploadFile(file);
        if (uploadFile.data.status === 200) {
          this.isSuccess = true;
          if (type === 'MAIN_IMAGE') {
            this.formData.image = uploadFile.data.data.file_id;
            this.formData.image_collect = uploadFile.data.data;
          }
        }
      } catch (error) {
        console.log(error);
        this.isSuccess = false;
        this.setFormError(error.response.data.error);
      } finally {
        this.isLoadingForm = false;
      }
    },
    setFormError(error) {
      if (typeof error === 'string' || error instanceof String) {
        this.hasErrorSingle = error;
      } else {
        Object.keys(error).forEach((item) => {
          this.hasFormError[item] = error[item][0];
        });
      }
    },
    resetForm(withContent = true, withLoading = true) {
      if (withContent) {
        this.formData = structuredClone(dataEvent);
      }
      this.hasFormError = structuredClone(dataEvent);
      this.hasErrorSingle = null;
      if (withLoading) {
        this.isLoadingForm = false;
      }
    },
    removeErrorFormSingle(key) {
      this.hasFormError[key] = null;
    },
  },
  getters: {},
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useEventStore, import.meta.webpackHot));
}
